import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../core/services/core.translate.service';

@Injectable()
export class FrsReleaseTiService {
    constructor(
        private stateService: StateService,
        private gfTranslateService: GfTranslateService
    ) { }

    // Not used in UI?
    getSortFields() {
        return {
            'id': this.gfTranslateService.translate('Id'),
            'priority': this.gfTranslateService.translate('Priority'),
            'summary': this.gfTranslateService.translate('Summary'),
            'lastModifiedDate': this.gfTranslateService.translate('Last Modified Date')
        };
    }
    getFetchParams(project) {
        return {
            project: project.id,
            release: this.stateService.params.releaseId,
            page_size: this.stateService.params.page_size,
            page_num: this.stateService.params.page_num,
            sort_field: this.stateService.params.sort_field,
            sort_dir: this.stateService.params.sort_dir
        };
    }
    getTrackerOptions() {
        return {
            fields: {
                priority: {
                    useInQuickBrowse: true,
                    isEnabled: true
                },
                status: {
                    useInQuickBrowse: true
                }
            },
            rel: { workflow: {} }
        };
    }
    getTIBOptions(release) {
        return {
            section: 'frs',
            showToolbar: false,
            addModal: true,
            addModalTitle: this.gfTranslateService.translate("Add New Tracker Item to FRS Release: {{releaseName}}", release),
            editModal: true,
            defaults: {
                extraFields: {
                    frs: {
                        id: release.id
                    }
                }
            }
        };
    }
}
